import React from "react";
import {
  background,
  Box,
  ButtonGroup,
  Flex,
  SimpleGrid,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import ModalTemplate from "../ModalTemplate";
import CustomButton from "../CustomButton";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  loading: boolean;
  title: string;
  content: string;
  onClose: () => void;
  onConfirm: () => void;
  buttonText?: string;
}

const ConfirmationModal: React.FC<Props> = ({
  content,
  onConfirm,
  onClose,
  open,
  title,
  loading,
  buttonText,
}) => {
  const { t } = useTranslation();
  const textColor = useColorModeValue("navy.700", "white");

  return (
    <>
      <ModalTemplate title={title} open={open} handleClose={onClose}>
        <Box>
          <Text fontSize={"x-large"} color={textColor}>
            {content}
          </Text>
          <SimpleGrid columns={1} spacing={10}>
            <Flex flexDirection="column">
              <ButtonGroup justifyContent="space-between" mt={8}>
                <CustomButton
                  handleClick={onClose}
                  title={t("common.button.cancel")}
                  loading={false}
                  variant="light"
                  sx={{ marginRight: "20px" }}
                />
                <CustomButton
                  handleClick={onConfirm}
                  title={buttonText ?? t("common.button.save")}
                  loading={loading}
                  sx={{
                    marginLeft: "20px",
                    background: "red",
                    _hover: {
                      background: "red",
                    },
                  }}
                />
              </ButtonGroup>
            </Flex>
          </SimpleGrid>
        </Box>
      </ModalTemplate>
    </>
  );
};

export default ConfirmationModal;
